export const LOCAL_STORAGE_KEY = {
  auth: {
    storeCode: 'AUTH_STORECODE',
  },
}
